module.exports = __webpack_public_path__ + "img/img_cx7_open.f0cdc52c.jpg";